import { useIntl } from "react-intl";

import { ReactComponent as CopyIcon } from "assets/images/iconsV2/copy.svg";
import { ReactComponent as TrashIcon } from "assets/images/iconsV2/trash-01.svg";
import { classNames } from "helpers/commonHelpers";

import "./RowActionMenu.scss";

type RowActionMenuProps = {
  onDuplicate: () => void;
  onDelete: () => void;
  deleteDisabled?: boolean;
};

export default function RowActionMenu({ onDuplicate, onDelete, deleteDisabled = false }: RowActionMenuProps) {
  const intl = useIntl();

  return (
    <div className="rfv2-packing-list-row-actions">
      <button
        type="button"
        className="rfv2-packing-list-row-actions__button"
        onClick={onDuplicate}
        aria-label={intl.formatMessage({
          id: "request-form.packing-list.duplicateRow",
          defaultMessage: "Duplicate row",
        })}
      >
        <CopyIcon />
      </button>
      <button
        type="button"
        className={classNames("rfv2-packing-list-row-actions__button", {
          "rfv2-packing-list-row-actions__button--disabled": deleteDisabled,
        })}
        disabled={deleteDisabled}
        onClick={() => {
          if (deleteDisabled) return;
          onDelete();
        }}
        aria-label={intl.formatMessage({
          id: "request-form.packing-list.deleteRow",
          defaultMessage: "Delete row",
        })}
      >
        <TrashIcon />
      </button>
    </div>
  );
}
